export const googlePlayUrlDefault = "https://play.google.com/store/apps/details?id=com.prodigypadelacademy.app&hl";
export const appStoreEnglish = "https://apps.apple.com/us/app/prodigy-padel-academy/id6463727496";
export const appStoreSpanish =  "https://apps.apple.com/es/app/prodigy-padel-academy/id6463727496?l=es_ES";

export const AppleLink = "https://apps.apple.com/app/prodigy-padel-academy/id6463727496"
export const AndroidLink = "https://play.google.com/store/apps/details?id=com.prodigypadelacademy.app"                      
export const AndroidLink2 = "market://details?id=com.prodigypadelacademy.app"